import { vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-78b4c065")

_pushScopeId("data-v-78b4c065")
const _hoisted_1 = { class: "content-color" }
const _hoisted_2 = {
  key: 0,
  style: {"color":"red","font-size":"10px"}
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" - ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_radio = _resolveComponent("el-radio")
  const _component_el_radio_group = _resolveComponent("el-radio-group")
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_el_form = _resolveComponent("el-form")
  const _component_cus_button = _resolveComponent("cus-button")
  const _component_dialog_shell = _resolveComponent("dialog-shell")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_dialog_shell, {
      title: _ctx.title,
      onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.emit('close'))),
      "footer-type": "customize"
    }, {
      footer: _withId(() => [
        _createVNode("div", null, [
          _createVNode(_component_cus_button, {
            onClick: _ctx.submit,
            type: "blue"
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.$wordList.ProperAllTextExport), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withId(() => [
        _withDirectives(_createVNode("a", {
          ref: "downloadRef",
          download: "",
          href: _ctx.downloadUrl
        }, null, 8, ["href"]), [
          [_vShow, false]
        ]),
        _createVNode(_component_el_form, {
          "label-position": _ctx.$formLabelPosition,
          model: _ctx.formData,
          rules: _ctx.rules,
          ref: "formRef"
        }, {
          default: _withId(() => [
            _createVNode(_component_el_form_item, {
              label: _ctx.$wordList.ProperAllTextExportLogTypeOfLogs
            }, {
              default: _withId(() => [
                _createVNode("div", _hoisted_1, _toDisplayString(_ctx.title), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.$wordList.ProperAllTextExportLogFormOfFile,
              prop: "ExportType"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: _ctx.formData.ExportType,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.ExportType = $event)),
                  class: "content-color"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_radio, { label: "1" }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(_ctx.$wordList.ProperAllTextLogsOnly), 1)
                      ]),
                      _: 1
                    }),
                    (_ctx.type !== 4)
                      ? (_openBlock(), _createBlock(_component_el_radio, {
                          key: 0,
                          label: "0"
                        }, {
                          default: _withId(() => [
                            _createTextVNode(_toDisplayString(_ctx.$wordList.ProperAllTextLogsAndCapture), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                (_ctx.formData.ExportType==='0')
                  ? (_openBlock(), _createBlock("p", _hoisted_2, _toDisplayString(_ctx.$wordList.ProperAllTextLogsAndCapturePrompt), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, { label: "Duration" }, {
              default: _withId(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.formData.BeginTime,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formData.BeginTime = $event)),
                  type: "date",
                  class: "TimeText",
                  disabled: _ctx.isEndDisable,
                  "disabled-date": _ctx.beginOptions
                }, null, 8, ["modelValue", "disabled", "disabled-date"]),
                _hoisted_3,
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.formData.EndTime,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.formData.EndTime = $event)),
                  type: "date",
                  class: "TimeText",
                  "disabled-date": _ctx.endOptions
                }, null, 8, ["modelValue", "disabled-date"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["label-position", "model", "rules"])
      ]),
      _: 1
    }, 8, ["title"])
  ]))
})